import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { DatePickerVertical } from '../../../components/DatePicker/DatePickerVertical';
import { SlideType } from '../../../models';
import { Fragment } from './Fragment';
import { FragmentBody } from './FragmentBody';
import { NextButton } from './NextButton';
import { CMS } from '../../../utils/CMS';
import { ConnectedSegmentDate } from '../Segment/SegmentDate';
import { DatePickerLegends } from '../../../components/DatePicker/DatePickerLegends';
import { ConnectedFaresTrackingCalculator } from '../../../components/Calendar/Context/FaresTrackingCalculator';
import { ABUtils, DateUtils } from '../../../utils';
import { canDisplayFaresInCalendar, isTrainsProductActive } from '../../../redux/currentSearch/selectors';
import { DatesFragmentHeader } from './DatesFragmentHeader';
import { TimePicker } from '../MobileFields/TimePicker';
import { useSegmentContext } from '../Segment/SegmentManager/Context';

export const DatesFragment = () => {
    const isTrainsProduct = useSelector((state) => isTrainsProductActive(state));
    const canDisplayFares = useSelector(canDisplayFaresInCalendar);
    const { isSearchByHourMobile: isSearchByHourMobileAB } = ABUtils.getABs();
    const isSearchByHourMobile = isSearchByHourMobileAB && isTrainsProduct;
    const { segment } = useSegmentContext();
    return (
        <ConnectedSegmentDate>
            {({ dates, minDate, maxDate, setValue, value, displayFaresInCalendar }) => {
                const { isCssVariationMobile } = ABUtils.getABs();
                const isDone = !!value;
                const stop = canDisplayFares || isSearchByHourMobile;

                const wrapperClassName = classNames({
                    'odf-box': true,
                    'prisma-elevation-1': isCssVariationMobile,
                });

                return (
                    <Fragment
                        id={SlideType.DATE}
                        isDone={isDone}
                        isEmpty={!isDone}
                        setValue={setValue}
                    >
                        {({ onSelectValue }) => (
                            <React.Fragment>
                                <DatesFragmentHeader />
                                <FragmentBody padding={false}>
                                    {!isCssVariationMobile && (
                                        <div className="odf-space-outer-m odf-text-soft odf-text-left odf-text-xl">
                                            <CMS id="flightsManager.selection.date.title" />
                                        </div>
                                    )}
                                    <DatePickerVertical
                                        dates={dates}
                                        displayFaresInCalendar={displayFaresInCalendar}
                                        value={value}
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        onChange={(value) => onSelectValue(value, stop)}
                                    />
                                </FragmentBody>
                                <div className={wrapperClassName} style={{ borderRadius: 0 }}>
                                    <DatePickerLegends displayFaresInCalendar={canDisplayFares} />
                                </div>
                                {isDone && (
                                    <ConnectedFaresTrackingCalculator trackType='continue_calendar'>
                                        {({ extraTracking }) => (
                                            <React.Fragment>
                                                {!isSearchByHourMobile && !canDisplayFares && (
                                                    <NextButton extraTracking={extraTracking} testId="dates-next-btn" />
                                                )}

                                                {isSearchByHourMobile && (
                                                    <TimePicker
                                                        isVisible
                                                        extraTracking={extraTracking}
                                                        selectedDate={DateUtils.stringToDate(value)}
                                                        segmentId={segment.id}
                                                    />
                                                )}
                                            </React.Fragment>
                                        )}
                                    </ConnectedFaresTrackingCalculator>
                                )}
                            </React.Fragment>
                        )}
                    </Fragment>
                );
            }}
        </ConnectedSegmentDate>
    );
};
